const inputConfig = {
  minPasswordLength: 8,
};

export default inputConfig;
